import { AxiosResponse, Canceler } from 'axios';
import { IPaginationResponseDto, IDisplayStyle, IHomeDisplayStyleCreateRequestDto } from '../types';
import settings from '../settings';
import api from './base';

export function getDisplayStyles(): [Promise<AxiosResponse<IPaginationResponseDto<IDisplayStyle>>>, Canceler] {
  const uri = `${settings.getApiURI()}/home/v1/display-styles`;

  return api.getWithCancel(uri);
}

export function createHomeDisplayStyle(homeDisplayStyle: IHomeDisplayStyleCreateRequestDto) {
  const uri = `${settings.getApiURI()}/home/v1/display-styles`;
  return api.http.post(uri, homeDisplayStyle);
}

export function getHomeDisplayStyles(page = 1, limit = 15): [Promise<AxiosResponse<any>>, Canceler] {
  const uri = `${settings.getApiURI()}/home/v1/display-styles?page=${page}&limit=${limit}`;

  return api.getWithCancel(uri);
}
